// Event Service Categories
export const EVENT_SERVICE_CATEGORIES = [
  // Decoration Services
  { value: "stage_decoration", label: "Stage Decoration", category: "Decoration", icon: "🎭" },
  { value: "mandap_decoration", label: "Mandap Decoration", category: "Decoration", icon: "🏛️" },
  { value: "floral_decoration", label: "Floral Decoration", category: "Decoration", icon: "🌸" },
  { value: "entrance_gate_decoration", label: "Entrance Gate Decoration", category: "Decoration", icon: "🚪" },
  { value: "haldi_decoration", label: "Haldi Decoration", category: "Decoration", icon: "💛" },
  { value: "mehendi_decoration", label: "Mehendi Decoration", category: "Decoration", icon: "🎨" },
  { value: "balloon_decoration", label: "Balloon Decoration", category: "Decoration", icon: "🎈" },
  { value: "theme_decoration", label: "Theme Based Decoration", category: "Decoration", icon: "✨" },
  
  // Venue & Planning Services
  { value: "marriage_lawn", label: "Marriage Lawn", category: "Venue", icon: "🌳" },
  { value: "banquet_hall", label: "Banquet Hall", category: "Venue", icon: "🏰" },
  { value: "farm_house", label: "Farm House", category: "Venue", icon: "🏡" },
  { value: "destination_venue", label: "Destination Wedding", category: "Venue", icon: "🌴" },
  { value: "wedding_planner", label: "Wedding Planner", category: "Venue", icon: "📋" },
  { value: "event_coordinator", label: "Event Manager", category: "Venue", icon: "👔" },
  
  // Event Infrastructure
  { value: "tent_pandal", label: "Tent / Pandal", category: "Infrastructure", icon: "⛺" },
  { value: "stage_setup", label: "Stage Setup", category: "Infrastructure", icon: "🎪" },
  { value: "generator_service", label: "Generator Service", category: "Infrastructure", icon: "⚡" },
  { value: "furniture_rental", label: "Furniture Rental", category: "Infrastructure", icon: "🪑" },
  { value: "ac_cooler_rental", label: "AC / Cooler Rental", category: "Infrastructure", icon: "❄️" },
  
  // Catering & Food Services
  { value: "full_catering", label: "Full Catering", category: "Catering", icon: "🍽️" },
  { value: "veg_catering", label: "Veg Catering", category: "Catering", icon: "🥗" },
  { value: "non_veg_catering", label: "Non-Veg Catering", category: "Catering", icon: "🍖" },
  { value: "wedding_cake", label: "Wedding Cake", category: "Catering", icon: "🎂" },
  { value: "dessert_counter", label: "Dessert Counter", category: "Catering", icon: "🍰" },
  { value: "live_food_counter", label: "Live Food Counter", category: "Catering", icon: "👨‍🍳" },
  { value: "bartender_service", label: "Bartender / Bar Service", category: "Catering", icon: "🍹" },
  { value: "chai_coffee_counter", label: "Chai / Coffee Counter", category: "Catering", icon: "☕" },
  
  // Photography & Videography
  { value: "wedding_photography", label: "Wedding Photography", category: "Photography", icon: "📷" },
  { value: "wedding_videography", label: "Wedding Videography", category: "Photography", icon: "🎥" },
  { value: "pre_wedding_shoot", label: "Pre-Wedding Shoot", category: "Photography", icon: "💑" },
  { value: "drone_photography", label: "Drone Photography", category: "Photography", icon: "🚁" },
  { value: "candid_photography", label: "Candid Photography", category: "Photography", icon: "📸" },
  { value: "album_design", label: "Wedding Album Design", category: "Photography", icon: "📖" },
  { value: "video_editing", label: "Video Editing", category: "Photography", icon: "🎬" },
  
  // Makeup & Styling
  { value: "bridal_makeup", label: "Bridal Makeup", category: "Makeup", icon: "💄" },
  { value: "groom_makeup", label: "Groom Makeup", category: "Makeup", icon: "🧔" },
  { value: "mehendi_artist", label: "Mehendi Artist", category: "Makeup", icon: "🖐️" },
  { value: "hairstylist", label: "Hairstylist", category: "Makeup", icon: "💇" },
  { value: "pre_bridal_spa", label: "Pre-Bridal Spa & Grooming", category: "Makeup", icon: "💆" },
  { value: "saree_draping", label: "Saree Draping", category: "Makeup", icon: "👗" },
  
  // Entertainment & Music
  { value: "dj_service", label: "DJ Service", category: "Entertainment", icon: "🎧" },
  { value: "band_baja", label: "Band Baja", category: "Entertainment", icon: "🎺" },
  { value: "ghodi_horse", label: "Ghodi (Horse for Baraat)", category: "Entertainment", icon: "🐴" },
  { value: "sound_system_rental", label: "Sound System Rental", category: "Entertainment", icon: "🔊" },
  { value: "live_singer", label: "Live Singer", category: "Entertainment", icon: "🎤" },
  { value: "anchor_emcee", label: "Anchor / Emcee", category: "Entertainment", icon: "🎙️" },
  { value: "dance_choreographer", label: "Dance Choreographer", category: "Entertainment", icon: "💃" },
  { value: "magician", label: "Magician / Entertainer", category: "Entertainment", icon: "🎩" },
  
  // Lighting & Special Effects
  { value: "roadlight_rath", label: "Roadlight / Rath for Dwarpuja", category: "Lighting", icon: "🛕" },
  { value: "wedding_lighting", label: "Wedding Lighting", category: "Lighting", icon: "💡" },
  { value: "led_screen", label: "LED Screen Rental", category: "Lighting", icon: "📺" },
  { value: "laser_lights", label: "Laser Lights", category: "Lighting", icon: "✨" },
  { value: "fog_machine", label: "Fog / Smoke Machine", category: "Lighting", icon: "🌫️" },
  { value: "fireworks", label: "Fireworks", category: "Lighting", icon: "🎆" },
  { value: "cold_fireworks", label: "Cold Fireworks", category: "Lighting", icon: "🎇" },
  
  // Transportation Services
  { value: "wedding_car", label: "Wedding Car Decoration", category: "Transportation", icon: "🚗" },
  { value: "vintage_car", label: "Vintage Car Rental", category: "Transportation", icon: "🚙" },
  { value: "luxury_car", label: "Luxury Car Rental", category: "Transportation", icon: "🚘" },
  { value: "bus_rental", label: "Bus Rental for Guests", category: "Transportation", icon: "🚌" },
  { value: "valet_parking", label: "Valet Parking Service", category: "Transportation", icon: "🅿️" },
  
  // Religious Services
  { value: "pandit_priest", label: "Pandit / Priest", category: "Religious", icon: "🕉️" },
  { value: "qazi_service", label: "Qazi Service", category: "Religious", icon: "☪️" },
  { value: "church_service", label: "Church Wedding Service", category: "Religious", icon: "✝️" },
  { value: "astrologer", label: "Astrologer / Muhurat", category: "Religious", icon: "🔮" },
  
  // Rental Services
  { value: "jewelry_rental", label: "Jewelry Rental", category: "Rental", icon: "💎" },
  { value: "costume_rental", label: "Costume Rental", category: "Rental", icon: "👘" },
  { value: "props_rental", label: "Props Rental", category: "Rental", icon: "🎭" },
  { value: "crockery_rental", label: "Crockery & Cutlery Rental", category: "Rental", icon: "🍴" },
  
  // Gifts & Favors
  { value: "return_gifts", label: "Return Gifts / Wedding Favors", category: "Gifts", icon: "🎁" },
  { value: "trousseau_packing", label: "Trousseau Packing", category: "Gifts", icon: "🎀" },
  { value: "gift_hampers", label: "Gift Hampers", category: "Gifts", icon: "🧺" },
  
  // Security & Logistics
  { value: "event_security", label: "Event Security Service", category: "Security", icon: "🛡️" },
  { value: "bouncer_service", label: "Bouncer Service", category: "Security", icon: "💪" },
  
  // Other Services
  { value: "invitation_printing", label: "Invitation Printing", category: "Other", icon: "💌" },
  { value: "invitation_distribution", label: "Invitation Distribution", category: "Other", icon: "📬" },
  { value: "rangoli_artist", label: "Rangoli Artist", category: "Other", icon: "🎨" },
  { value: "welcome_drinks", label: "Welcome Drinks Service", category: "Other", icon: "🥤" }
];

// Group service categories by category
export const GROUPED_SERVICE_CATEGORIES = EVENT_SERVICE_CATEGORIES.reduce((acc, service) => {
  if (!acc[service.category]) {
    acc[service.category] = [];
  }
  acc[service.category].push(service);
  return acc;
}, {});

// Main category options for two-step selection
export const MAIN_CATEGORY_OPTIONS = [
  { value: "Decoration", label: "🎨 Decoration Services", icon: "🎨" },
  { value: "Venue", label: "🏰 Venue & Planning", icon: "🏰" },
  { value: "Infrastructure", label: "⛺ Infrastructure", icon: "⛺" },
  { value: "Catering", label: "🍽️ Catering & Food", icon: "🍽️" },
  { value: "Photography", label: "📷 Photography & Videography", icon: "📷" },
  { value: "Makeup", label: "💄 Makeup & Styling", icon: "💄" },
  { value: "Entertainment", label: "🎧 Entertainment & Music", icon: "🎧" },
  { value: "Lighting", label: "💡 Lighting & Special Effects", icon: "💡" },
  { value: "Transportation", label: "🚗 Transportation Services", icon: "🚗" },
  { value: "Religious", label: "🕉️ Religious Services", icon: "🕉️" },
  { value: "Rental", label: "💎 Rental Services", icon: "💎" },
  { value: "Gifts", label: "🎁 Gifts & Favors", icon: "🎁" },
  { value: "Security", label: "🛡️ Security & Logistics", icon: "🛡️" },
  { value: "Other", label: "💌 Other Services", icon: "💌" }
];

// Service category options for react-select
export const SERVICE_CATEGORY_OPTIONS = EVENT_SERVICE_CATEGORIES.map(service => ({
  value: service.value,
  label: service.label
}));

// Get service label by value
export const getServiceLabel = (value) => {
  const service = EVENT_SERVICE_CATEGORIES.find(s => s.value === value);
  return service ? service.label : value;
};

// Get service category by value
export const getServiceCategory = (value) => {
  const service = EVENT_SERVICE_CATEGORIES.find(s => s.value === value);
  return service ? service.category : 'Other';
};

// Get service icon by value
export const getServiceIcon = (value) => {
  const service = EVENT_SERVICE_CATEGORIES.find(s => s.value === value);
  return service ? service.icon : '📋';
};

// Description templates for each service category
export const SERVICE_DESCRIPTION_TEMPLATES = {
  // Decoration Services
  stage_decoration: "Stage decoration for weddings and events. We make beautiful stage with lights, flowers, and decorations.",
  mandap_decoration: "Mandap decoration for weddings. We create beautiful mandap with fresh flowers and traditional decorations.",
  floral_decoration: "Flower decoration for all events. We use fresh flowers to make beautiful decorations.",
  entrance_gate_decoration: "Beautiful entrance gate decoration for your guests. We make welcome gates with flowers, lights, and decorations.",
  haldi_decoration: "Colorful haldi decoration with yellow theme. We create beautiful setups with marigold flowers and traditional decorations.",
  mehendi_decoration: "Beautiful mehendi ceremony decoration. We create colorful and bright setups for mehendi function.",
  balloon_decoration: "Creative balloon decoration for all events. We make balloon arches, pillars, and beautiful arrangements.",
  theme_decoration: "Custom theme decoration as per your choice. We create your dream decoration with creative designs.",
  roadlight_rath: "Roadlight and rath for dwarpuja ceremony. We provide decorated rath/chariot for traditional door entrance rituals.",
  
  // Venue & Planning Services
  marriage_lawn: "Open marriage lawn for weddings and events. We provide spacious lawn with lighting, seating arrangements, and basic facilities.",
  banquet_hall: "AC banquet hall with modern facilities. We offer big halls with catering, AC, and complete event support.",
  farm_house: "Farm house for weddings and events. We provide open space with natural surroundings and basic facilities.",
  destination_venue: "Destination wedding at beautiful locations. We arrange complete wedding packages with stay and food.",
  wedding_planner: "Complete wedding planning from start to end. We manage everything to make your wedding stress-free.",
  event_coordinator: "Event manager for smooth wedding. We handle all vendors, timing, and arrangements professionally.",
  
  // Infrastructure Services
  tent_pandal: "Tent and pandal for outdoor events. We provide strong tents in different sizes for your guests.",
  stage_setup: "Stage setup with sound and lighting. We build proper stage with all equipment needed.",
  generator_service: "Generator on rent for power backup. We provide silent generators of different sizes for your event.",
  furniture_rental: "Furniture on rent for events. We provide chairs, tables, sofas in different styles.",
  ac_cooler_rental: "AC and cooler on rent for comfort. We provide cooling for indoor and outdoor events.",
  
  // Catering & Food Services
  full_catering: "Complete food catering with different types of dishes. We serve tasty food for all types of events.",
  veg_catering: "Pure vegetarian food catering. We make tasty veg dishes prepared with cleanliness.",
  non_veg_catering: "Non-veg food catering. We serve delicious non-veg dishes made by experienced cooks.",
  wedding_cake: "Custom wedding cake making and delivery. We make beautiful cakes in different flavors and designs.",
  dessert_counter: "Live sweet counter with variety. We set up sweet stations with traditional and modern items.",
  live_food_counter: "Live food making counter. We make pasta, chaat, dosa, and other items live in front of guests.",
  bartender_service: "Bar service for events. We provide bartender with drinks and bar setup.",
  chai_coffee_counter: "Tea and coffee counter for guests. We serve fresh chai, coffee, and other drinks.",
  
  // Photography & Videography
  wedding_photography: "Wedding photo shooting. We take good quality photos with camera and give edited pictures.",
  wedding_videography: "Wedding video making. We make beautiful wedding videos with good editing.",
  pre_wedding_shoot: "Pre-wedding photo shoot at nice places. We take your couple photos before wedding.",
  drone_photography: "Drone camera for photos and videos. We take photos and videos from sky with drone.",
  candid_photography: "Natural photo clicking. We take photos of real moments and emotions without posing.",
  album_design: "Wedding album making and printing. We make beautiful photo albums with good quality.",
  video_editing: "Video editing for weddings. We edit your wedding videos and make them look good.",
  
  // Makeup & Styling
  bridal_makeup: "Bridal makeup with good products. We make the bride look beautiful for whole day.",
  groom_makeup: "Groom makeup and grooming. We make the groom look smart and handsome.",
  mehendi_artist: "Mehendi artist for beautiful designs. We make all types of mehendi designs from simple to heavy.",
  hairstylist: "Hair styling for weddings and events. We make beautiful hairstyles matching your dress.",
  pre_bridal_spa: "Beauty treatment before wedding. We do facial, body treatment, and beauty services.",
  saree_draping: "Saree wearing service in different styles. We drape saree in Bengali, Gujarati, and modern styles.",
  
  // Entertainment & Music
  dj_service: "DJ service with latest songs and equipment. We play music and keep your guests entertained.",
  band_baja: "Traditional band baja for weddings. We play dhol, shehnai, and band music.",
  ghodi_horse: "Decorated horse for groom's baraat entry. We provide trained horses with beautiful decorations.",
  sound_system_rental: "Sound system on rent. We provide speakers, mic, and sound equipment.",
  live_singer: "Live singer for weddings and events. We sing bollywood, classical, and other songs.",
  anchor_emcee: "Anchor for event hosting. We host your event with good energy and entertainment.",
  dance_choreographer: "Dance teacher for sangeet. We teach dance for wedding and special occasions.",
  magician: "Magician for entertainment. We do magic shows for fun and entertainment for all people.",
  
  // Lighting & Special Effects
  wedding_lighting: "Wedding lights and decoration lights. We set up LED lights, fancy lights, and all types of lighting.",
  led_screen: "LED screen on rent. We provide big LED screens for showing videos and live streaming.",
  laser_lights: "Laser light show for weddings. We create beautiful light effects with laser.",
  fog_machine: "Fog machine for effects. We create smoke effects for entry and dance performances.",
  fireworks: "Fireworks display service. We provide licensed fireworks with safe handling.",
  cold_fireworks: "Cold fireworks for indoor and outdoor. We provide safe fireworks without smoke.",
  
  // Transportation Services
  wedding_car: "Wedding car decoration with flowers. We decorate cars beautifully for bride and groom.",
  vintage_car: "Old model car on rent for weddings. We provide classic cars with driver.",
  luxury_car: "Luxury car on rent. We provide expensive cars with driver for special occasions.",
  bus_rental: "AC and non-AC bus on rent. We provide comfortable buses with driver for guests.",
  valet_parking: "Parking service for events. We manage parking of guest vehicles with our staff.",
  
  // Religious Services
  pandit_priest: "Pandit for Hindu wedding rituals. We do all traditional ceremonies with proper mantras.",
  qazi_service: "Qazi for Muslim wedding nikah. We conduct nikah ceremony as per Islamic rules.",
  church_service: "Church wedding ceremony service. We help with Christian wedding arrangements.",
  astrologer: "Astrologer for muhurat and kundli. We select good wedding dates and match kundli.",
  
  // Rental Services
  jewelry_rental: "Jewelry on rent for weddings. We give beautiful necklace, earrings, and jewelry sets.",
  costume_rental: "Dress on rent for wedding. We provide sherwani, gown, and traditional outfits.",
  props_rental: "Photo booth and props on rent. We give fun items and backgrounds for photos.",
  crockery_rental: "Plates and utensils on rent. We provide plates, glasses, and serving items.",
  
  // Gifts & Favors
  return_gifts: "Return gifts for guests. We provide gifts for guests with packing and delivery.",
  trousseau_packing: "Trousseau packing service. We pack wedding items beautifully in traditional style.",
  gift_hampers: "Gift hampers for weddings. We make beautiful gift boxes with selected items.",
  
  // Security & Logistics
  event_security: "Security service for events. We provide trained guards for safety of your event.",  
  bouncer_service: "Bouncers for crowd control. We provide strong bouncers for VIP security.",
  
  // Other Services
  invitation_printing: "Wedding card printing. We design and print beautiful invitation cards.",
  invitation_distribution: "Card distribution service. We give your invitation cards to all guests personally.",
  rangoli_artist: "Rangoli artist for wedding. We make beautiful rangoli designs at entrance.",
  welcome_drinks: "Welcome drink service. We serve cold drinks to guests when they arrive."
};

// Generate description based on selected services
export const generateServiceDescription = (selectedServices, experience, teamSize) => {
  if (!selectedServices || selectedServices.length === 0) {
    return "";
  }

  const serviceNames = selectedServices.map(s => getServiceLabel(s.value)).join(", ");
  let description = `We provide ${serviceNames} services. `;

  // Add experience if available
  if (experience && experience > 0) {
    description += `We have ${experience}+ years experience in this work. `;
  }

  // Add team size if available
  if (teamSize && teamSize > 0) {
    description += `Our team has ${teamSize} workers who are skilled in this work. `;
  }

  // Add service-specific details
  if (selectedServices.length === 1) {
    const template = SERVICE_DESCRIPTION_TEMPLATES[selectedServices[0].value];
    if (template) {
      description += template;
    }
  } else {
    description += "We do good quality work and make customers happy.";
  }

  return description;
};

// Get quick description suggestions based on service category
export const getDescriptionSuggestions = (mainCategoryValue) => {
  const suggestions = {
    Decoration: [
      "Tell what type of decoration you do (traditional, modern, theme)",
      "Mention what flowers or materials you use",
      "Tell how you setup and clean after event"
    ],
    Venue: [
      "Tell how many people can sit in your venue",
      "Mention if you provide rooms for stay",
      "Tell about location and parking space"
    ],
    Infrastructure: [
      "Tell what size tent or equipment you have",
      "Mention if it works in rain or bad weather",
      "Tell how you setup safely"
    ],
    Catering: [
      "Tell what type of food you make (North Indian, South Indian, etc.)",
      "Mention if you have FSSAI certificate for hygiene",
      "Tell how you serve food (buffet system, plate service, live counter)"
    ],
    Photography: [
      "Tell what camera and equipment you use",
      "Mention your style (natural photos, traditional pose, video style)",
      "Tell how many photos/videos you give and in how many days"
    ],
    Makeup: [
      "Tell what makeup brands you use",
      "Mention what type makeup you do best (bridal, party, HD)",
      "Tell if you do makeup trial before event"
    ],
    Entertainment: [
      "Tell what songs or music style you play",
      "Mention what sound equipment you have",
      "Tell what type of events you have done before"
    ],
    Lighting: [
      "Tell what type of lights you have (LED, laser, etc.)",
      "Mention about safety and power needed",
      "Tell how you control the lights"
    ],
    Transportation: [
      "Tell what vehicles you have (car model, bus type)",
      "Mention about vehicle condition and cleaning",
      "Tell about driver experience and which areas you cover"
    ],
    Religious: [
      "Tell what religious ceremonies you perform",
      "Mention in which language you do the rituals",
      "Tell about your experience with community traditions"
    ],
    Rental: [
      "Tell what items you give on rent and how many",
      "Mention about quality and condition of items",
      "Tell about advance money, delivery, and return process"
    ],
    Gifts: [
      "Tell what customization you can do on gifts",
      "Mention how you pack and present the gifts",
      "Tell price range and discount for bulk orders"
    ],
    Security: [
      "Tell about guard training and certificates",
      "Mention how many years security experience you have",
      "Tell how you handle crowd management"
    ],
    Other: [
      "Tell what special things you offer in your service",
      "Mention about your quality and materials used",
      "Tell about happy customers and their feedback"
    ]
  };

  return suggestions[mainCategoryValue] || suggestions.Other;
};

// ID Proof Type Options (reusable for all services)
export const ID_PROOF_TYPE_OPTIONS = [
  { value: "Aadhaar", label: "Aadhaar" },
  { value: "PAN", label: "PAN" },
  { value: "VoterID", label: "Voter ID" },
  { value: "DrivingLicense", label: "Driving License" },
  { value: "Other", label: "Other" }
];
